import { PessoaContato } from "../types/pessoa_contato";

export const novaPessoaContato = (): PessoaContato => {
  return {
    tipo: "Principal",
    celular: "",
    nome: "",
    observacoes: "",
    pessoa_id: "",
  };
};
